module.exports = __webpack_public_path__ + "static/media/IMG2.b6996772.png";